import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Space } from 'antd';
import {
  BranchesOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseOutlined,
  UserAddOutlined, UserDeleteOutlined
} from '@ant-design/icons';

import {
  changeCodeAssignee,
  changeCodeReviewStatus,
} from '../../Helpers/Code.js';

function ReviewStatus(props) {
  const { t } = useTranslation();
  const [codeAssignee, setCodeAssignee] = useState('');
  const [codeReviewStatus, setCodeReviewStatus] = useState('');

  useEffect(() => {
    setCodeAssignee(props.code.assignee ? props.code.assignee : '');
    setCodeReviewStatus(props.code.review_status);
  }, [props]);

  function onChangeCodeReviewStatus(newStatus) {
    changeCodeReviewStatus(props.code.id, newStatus).then(data => {
      if (data.success === 1) setCodeReviewStatus(newStatus);
    });
  }

  function onChangeCodeAssignee(newAssignee) {
    changeCodeAssignee(props.code.id, newAssignee).then(data => {
      if (data.success) setCodeAssignee(newAssignee);
    });
  }

  /* Author button — colored by the status it transitions to */
  let requestBtn = null;
  if (props.userData.id === props.code.author) {
    const isPending =
      codeReviewStatus !== 'NOT_REQUESTED' &&
      codeReviewStatus !== 'SOLVED' &&
      codeReviewStatus;
    requestBtn = (
      <Button
        id="request-code-review-button"
        size="small"
        className={isPending ? 'cs-btn-st-open' : 'cs-btn-st-pending'}
        icon={isPending ? <CloseOutlined /> : <BranchesOutlined />}
        onClick={() =>
          onChangeCodeReviewStatus(isPending ? 'NOT_REQUESTED' : 'PENDING')
        }
      >
        {isPending ? t('Cancel code review request') : t('Request code review')}
      </Button>
    );
  }

  /* Admin buttons */
  let markBtn = null;
  let assignBtn = null;
  if (props.userData.role === 'ADMIN') {
    const isSolved = codeReviewStatus === 'SOLVED';
    markBtn = (
      <Button
        id="mark-code-review-button"
        size="small"
        className={isSolved ? 'cs-btn-st-pending' : 'cs-btn-st-solved'}
        icon={isSolved ? <ClockCircleOutlined /> : <CheckCircleOutlined />}
        onClick={() =>
          onChangeCodeReviewStatus(isSolved ? 'PENDING' : 'SOLVED')
        }
      >
        {isSolved ? t('Mark as pending') : t('Mark as solved')}
      </Button>
    );

    const isAssigned = codeAssignee && codeAssignee !== '';
    assignBtn = (
      <Button
        id="assign-code-button"
        size="small"
        className={isAssigned ? 'cs-btn-st-danger' : 'cs-btn-st-solved'}
        icon={isAssigned ? <UserDeleteOutlined /> : <UserAddOutlined />}
        onClick={() =>
          onChangeCodeAssignee(isAssigned ? null : props.userData.id)
        }
      >
        {isAssigned ? t('Unassign code review') : t('Assign code review')}
      </Button>
    );
  }

  const titleText = props.code.title || props.code.id || '';

  return (
    <div className="cs-review-status">
      <div className="cs-review-status__meta">
        <span>{`${t('Title')}: ${titleText}`}</span>
        <span>{`${t('Code review status')}: ${t(codeReviewStatus)}`}</span>
        <span>{`${t('Code review assignee')}: ${codeAssignee || ''}`}</span>
      </div>

      <Space wrap>
        {requestBtn}
        {markBtn}
        {assignBtn}
      </Space>
    </div>
  );
}

export default ReviewStatus;
